import { gql } from '@apollo/client/core';

export const CreateBillingContract = gql`
  mutation ($data: ContractCreateInput!) {
    createContract(data: $data) {
      id
    }
  }
`;
